import React, { FC, } from 'react';
import '../style/temp.less';

export interface Props {
    dataField?: any
    index: number
}
interface SetProps {
    dataField?: any
    id?: string
    methods?: any
    selectedInfo?: any
    otherInfo?: any
}

const ColumnNav: FC<Props> = ({ dataField }) => {
    return (
        <div className="preview-container" >
            ColumnNav
        </div>
    )
}

export const ColumnNavSet: FC<SetProps> = ({ dataField, id }) => {

    return <div className="setting-container">
        ColumnNav
    </div>
}

export default ColumnNav